/** Canonical GP (Gram Panchayat) master list per block.
 *  Keys must match FIELD_EXECUTION_BLOCKS exactly. */
export const BLOCK_GP_MASTER: Record<string, string[]> = {
    'Dhamanagar': [
        'Bhagabanpur', 'Gadiali', 'Nadigan', 'Katasahi', 'Daipur',
        'Khaparpada', 'Bhattasahi', 'Mustafapur', 'Hasnabad', 'Dhusuri',
        'Govindpur', 'Arjunnpur', 'Dalanga', 'Padhani', 'Kasimpur',
        'Khadipada', 'Karada', 'Dobal', 'Fatepur', 'Sahaspur',
        'Bamkura', 'Kothar', 'Palasahi', 'Kalyani', 'Chudakuti',
        'Radhabalabhpur', 'Anandapur', 'Bayangdihi', 'Raipur', 'Sohada',
        'Asurali',
    ],
    'Tihidi': [
        'Bilana', 'Kanpada', 'Kubera', 'Achak', 'Talapada',
        'Nayananda', 'Dolasahi', 'Talagopabindha', 'Baro', 'Shyamsundarpur',
        'Bodak', 'Guamal', 'Paliabindha',
    ],
    'Dhamanagar NAC': ['Nac'],
    'Tihidi NAC':     ['Nac'],
    'Dhusuri NAC':    ['Nac'],
};

/**
 * Maps known Firestore spelling variants (lowercase, spaces stripped) → canonical GP name.
 * Applied before the master-list lookup so misspelled project villages merge into the right GP row.
 */
export const GP_NAME_ALIASES: Record<string, string> = {
    // Dhamanagar block
    'arjunpur':         'Arjunnpur',
    'arjunpura':        'Arjunnpur',
    'arjunnpura':       'Arjunnpur',
    'asorali':          'Asurali',
    'asuarali':         'Asurali',
    'ashorali':         'Asurali',
    // 'bataranki' — not in official list; leave unmapped so it stays visible for review
    'bhagabanpura':     'Bhagabanpur',
    'bhagabanpurj':     'Bhagabanpur',
    'bhagwanpur':       'Bhagabanpur',
    'bhagabanpure':     'Bhagabanpur',
    'bbpur':            'Bhagabanpur',
    'gadialia':         'Gadiali',
    'khparpada':        'Khaparpada',
    'nadigaon':         'Nadigan',
    'dovabil':          'Dobal',
    'dovabilgp':        'Dobal',
    'katasahee':        'Katasahi',
    'katasahie':        'Katasahi',
    'daipur gp':        'Daipur',
    'khaperpada':       'Khaparpada',
    'khapurpada':       'Khaparpada',
    'bhattasahee':      'Bhattasahi',
    'bhattasahie':      'Bhattasahi',
    'mustafapur gp':    'Mustafapur',
    'hasnabad gp':      'Hasnabad',
    'dhuasuri':         'Dhusuri',
    'dhusuri gp':       'Dhusuri',
    'gobindpur':        'Govindpur',
    'gobindpura':       'Govindpur',
    'govindpura':       'Govindpur',
    'dalanga gp':       'Dalanga',
    'padhani gp':       'Padhani',
    'kasimpur gp':      'Kasimpur',
    'khadipada gp':     'Khadipada',
    'karada gp':        'Karada',
    'dobal gp':         'Dobal',
    'fatepur gp':       'Fatepur',
    'sahaspur gp':      'Sahaspur',
    'bamkura gp':       'Bamkura',
    'kothar gp':        'Kothar',
    'palasahi gp':      'Palasahi',
    'kalyani gp':       'Kalyani',
    'chudakuti gp':     'Chudakuti',
    'radhabalabhapur':  'Radhabalabhpur',
    'radhabalabpur':    'Radhabalabhpur',
    'anandapur gp':     'Anandapur',
    'bayangdihi gp':    'Bayangdihi',
    'raipur gp':        'Raipur',
    'sohada gp':        'Sohada',
    'asurali gp':       'Asurali',
    // Tihidi block
    'bilana gp':        'Bilana',
    'kanpada gp':       'Kanpada',
    'kubera gp':        'Kubera',
    'achak gp':         'Achak',
    'talapada gp':      'Talapada',
    'nayananda gp':     'Nayananda',
    'dolasahi gp':      'Dolasahi',
    'talagopabindha gp':'Talagopabindha',
    'baro gp':          'Baro',
    'shyamsundarpur gp':'Shyamsundarpur',
    'bodak gp':         'Bodak',
    'guamal gp':        'Guamal',
    'paliabindha gp':   'Paliabindha',
    'talagopavindha':   'Talagopabindha',
    'talagopavinda':    'Talagopabindha',
};
